// extracted by mini-css-extract-plugin
export var fadeInOut = "_11-3";
export var icon = "_11-4";
export var savedIndicator = "_11-2";
export var savingIndicator = "_11-0";
export var spin = "_11-1";